export const DataType = {
    TEXT: "text",
    NUMBER: "number",
    DATE: "date",
    ACTION: "Action"
}